/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import {
  openScheduler,
  WealthyEnv
} from "helpers";

const propTypes = {
  closePopUp: PropTypes.func.isRequired
};

const ScheduleMeetingPopUp = ({closePopUp}) =>  {
  const initCalendly = (e) => {
    const {name: route} = e.currentTarget;
    const baseURL = `${WealthyEnv.CALENDLY_URL}/team-wealthy`;
    openScheduler(`${baseURL}/${route}`);
  };
  const scheduleIllustration = `${WealthyEnv.CDN_URL}/articles/schedule-popup-illustration.png`;

  return (
    <Overlay>
      <PopUpContainer id="schedule-meeting-popup">
        <PopUp>
          <ImageContainer>
            <CoverImage src={scheduleIllustration} />
          </ImageContainer>
          <ContentContainer>
            <Heading>
              <span className="highlight-text">
                Free call
              </span> with a Wealth Manager
            </Heading>
            <Text>
              Our trained Wealth Managers are just a call away. Schedule a no-obligation free call on all matters money
            </Text>
            <ButtonContainer>
              <SubmitButton
                className="is-primary"
                id="schedule-meeting-popup--button"
                name="free-call"
                onClick={initCalendly}
              >
                Yes, do it
              </SubmitButton>
              <SubmitButton onClick={closePopUp}>
                Maybe later
              </SubmitButton>
            </ButtonContainer>
            <CloseButton onClick={closePopUp} />
          </ContentContainer>
        </PopUp>
      </PopUpContainer>
    </Overlay>
  );
};

const Overlay = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
`;

const PopUpContainer = styled.section`
  width: 100%;
  text-align: center;
  overflow: hidden;
  display: flex;
  max-width: 1040px;
  justify-content: center;
  position: relative;
`;

const PopUp = styled.div`
  position: relative;
  background: white;
  width: 70%;
  padding: 5rem;
  color: #464646;
  border-radius: 5px;
  display: flex;
  align-items: center;

  @media (max-width: 48em) {
    flex-direction: column;
    width: 90%;
    max-width: 400px;
    padding: 5rem 3rem;
    max-width: 400px;
  }
`;

const ImageContainer = styled.div`
  flex: 1;
`;

const ContentContainer = styled.div`
  flex: 2;
  text-align: left;
  margin-left: 2rem;

  @media (max-width: 48em) {
    margin: 1rem 0 0;
  }
`;

const ButtonContainer = styled.div`
  justify-self: center;
  display: flex;
  align-self: center;
  align-items: center;
  margin: 2rem auto 0;

  .is-primary {
    background: #ea2062;
    color: #fff;
    margin-right: 1rem;

    &:hover {
      opacity: 0.8;
    }
  }

  @media (max-width: 48em) {
    justify-content: center;
  }
`;

const SubmitButton = styled.button`
  display: inline-block;
  border: 2px solid #ea2062;
  background: #fff;
  color: #ea2062;
  width: 50%;
  max-width: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  padding: 1rem;
  font-size: 1.4rem;
  z-index: 1;
  border-radius: none;
  font-family: Avenir-Medium;
  cursor: pointer;

  &:hover {
    background: #ea2062;
    color: #fff;
  }
`;

const CoverImage = styled.img`
  width: 90%;
  margin: 0 auto;
  max-width: 100%;
  max-height: 100%;

  @media (max-width: 48em) {
    max-width: 180px;
  }
`;

const Heading = styled.h2`
  font-family: Avenir-Heavy;
  font-size: 2.6rem;
  line-height: 1.4;
  color: #ea2062;

  .highlight-text {
    color: #6588cd;
  }

  @media (max-width: 48em) {
    font-size: 3rem;
    text-align: center;
  }
`;

const CloseButton = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  background: transparent;
  border-radius: 50%;
  margin: 0.5rem;
  cursor: pointer;
  display: inline-block;

  &::before,
  &::after {
    content: "";
    margin-left: -12px;
    margin-top: -2px;
    left: 50%;
    top: 50%;
    width: 18px;
    height: 3px;
    background-color: #c3c9ec;
    position: absolute;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`;

const Text = styled.p`
  font-family: Avenir-Light;
  font-size: 1.6rem;
  margin: 0 auto 0;
  line-height: 1.5;
  color: #9a5c71;

  @media (max-width: 48em) {
    font-size: 1.5rem;
    margin-top: 0.5rem;
  }
`;

ScheduleMeetingPopUp.propTypes = propTypes;

export default ScheduleMeetingPopUp;
